import { Button, DialogActions } from '@mui/material'

// others
import { FormProvider, useForm } from 'react-hook-form'
import { AddReferralSourceProps } from '../../interfaceTypes/props'
import { useCreateReferralSourceMutation, useUpdateReferralSourceMutation } from '../../../generated'

// components
import { Alert } from '../common/Alert'
import { CustomModal } from '../common/CustomModal'
import { CustomController } from '../common/CustomController'
import { yupResolver } from '@hookform/resolvers/yup'
import { referralSourceSchema } from '../../validationSchema'

const AddReferralSource = ({ isOpen, handleClose, refetch, referralSource }: AddReferralSourceProps) => {
  const methods = useForm({
    resolver: yupResolver(referralSourceSchema),
    defaultValues: {
      sourceType: referralSource?.sourceType ?? ''
    }
  })

  const [createReferralSource, { loading }] = useCreateReferralSourceMutation({
    onError: error => {
      console.log('Error creating referral source:', error)
    },
    onCompleted: data => {
      const { createReferralSource } = data
      if (createReferralSource) {
        Alert.success('Referral Type Created!')
        handleClose()
        refetch?.()
        reset()
      }
    }
  })

  const [updateReferralSource, { loading: updating }] = useUpdateReferralSourceMutation({
    onError: error => {
      console.log('Error creating referral source:', error)
    },
    onCompleted: data => {
      const { updateReferralSource } = data
      if (updateReferralSource) {
        Alert.success('Referral Type Updated!')
        handleClose()
        refetch?.()
        reset()
      }
    }
  })

  const { handleSubmit, reset } = methods
  const onSubmit = async ({ sourceType }: { sourceType: string }) => {
    referralSource?.id
      ? await updateReferralSource({
          variables: {
            updateReferralSourceId: referralSource.id,
            sourceType
          }
        })
      : await createReferralSource({
          variables: {
            sourceType
          }
        })
  }

  const onClose = () => {
    handleClose()
    reset()
  }

  return (
    <CustomModal title={`${referralSource?.id ? 'Edit' : 'Add'}  Referral Type`} isOpen={isOpen} handleClose={onClose}>
      <FormProvider {...methods}>
        <form
          onSubmit={event => {
            event.stopPropagation()
            return handleSubmit(onSubmit)(event)
          }}
        >
          <CustomController controllerLabel="Referral Type" fullWidth controllerName="sourceType" required />
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button variant="contained" type="submit" disabled={loading || updating}>
              {referralSource?.id ? 'Update' : 'Create'}
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </CustomModal>
  )
}

export default AddReferralSource
